module.exports = __webpack_public_path__ + "img/ticket-office.d3045a67.svg";